<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/ActionsDictionary/queries/actionsDictionary.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        id: { control: 'text', dataType: Number },
        operationName: { control: 'text', modifier: 'contains' },
        actionAuthor: { control: 'text', modifier: 'contains' },
        scope: { control: 'text' },
        createdAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="100 || $options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          item-key="id+scope"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <!-- <span v-on="on">{{
                  $t(`events-categories.header-titles.${h.value}`)
                }}</span> -->
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value], '0') }}
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.value === 'actionAuthor'">
                <router-link
                  v-if="item.actionAuthor.id && item.actionAuthor.id !== 'N/A'"
                  :to="{
                    name: 'page-account',
                    params: { id: item.actionAuthor.id }
                  }"
                  title="Открыть"
                >
                  {{ getActionAuthor(item.actionAuthor) }}
                </router-link>
                <p v-else-if="item.actionAuthor.login !== 'N/A'">
                  {{ getActionAuthor(item.actionAuthor) }}
                </p>
              </div>
              <div v-else-if="h.value === 'ip'">
                {{ item.actionAuthor.ip }}
              </div>
              <div v-else-if="h.value === 'payload'">
                <router-link
                  v-if="getLinkTo(item)"
                  :to="getLinkTo(item)"
                  title="Открыть"
                >
                  {{ getName(item) }}
                </router-link>
                <p v-else>
                  {{ getName(item) }}
                </p>
              </div>
              <div v-else-if="h.type === 'array'">
                {{ item[h.value].join(' ') }}
              </div>
              <div v-else-if="h.type === 'actions'">
                <v-btn v-if="item.payload?.data" icon small @click="$emit('open-item', item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
  </div>
</template>

<script>
import headersConfig from './headersConfig.js'
import DateTimeCell from '@/components/date-time-cell/DateTimeCell'
import DataTableWrapper from '@/components/data-table-wrapper/DataTableWrapper'
import DataTableFilters from '@/components/data-table-filters/DataTableFilters'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import { formatAmount } from '@/utils'
import { getLink } from '@/utils/getActionsDictionary'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import { convertToPhone } from '@/configs/numbers'
import perPage from '@/configs/v-data-table'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'

export default {
  name: 'GridActionsDictionary',
  gridType: 'actionsDictionary',
  components: {
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell
  },
  headersConfig,
  perPage,
  mixins: [gridDependentMixin],
  data () {
    return {
      queryState: null
    }
  },
  methods: {
    formatAmount,
    convertToPhone,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    getLinkTo (item) {
      if (item?.operationName.match(/delete/i)) { return false }
      return getLink(item)
    },
    getActionAuthor (user) {
      if (user?.phone && user?.phone !== 'N/A') {
        return convertToPhone(user.phone)
      } else if (user?.email && user?.email !== 'N/A') {
        return user.email
      } else { return '' }
    },
    getName (item) {
      let name = false
      if (item.payload?.data) {
        if (Object.keys(item.payload?.data).find(i => i.match(/name/mgi))) {
          name = item.payload?.data[Object.keys(item.payload?.data).find(i => i.match(/name/mgi))]
        }
      }
      return item.payload?.data?.title ||
        name ||
        (item.operationName.match(/updateStatus/i) && item.payload?.data?.status
          ? `${item.scope} задан ${item.payload?.data?.status}` : false) ||
        (item?.scope === 'sharedAccess' && item.payload?.data?.login
          ? `${item.payload?.data?.login} запросил доступ к ${item.payload?.data?.profileType}` : false) ||
        convertToPhone(item.payload?.data?.login) ||
        convertToPhone(item.payload?.login) ||
        item.payload?.name ||
        item?.id ||
        false
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    }
  },
  async: {
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
  font-weight: 800;
}
</style>
